import type { TrendListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoCategory } from './trendListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoCategory';

/**
 * 트렌드 기본 정보
 */
export type TrendListResponsePageAllOfThreeContentItemBasicInfoAllOfTwo = {
  category?: TrendListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoCategory;
  name: string;
};
